export const appStates = {
    LOADING: 'Loading',
    DOWNLOADING: 'Downloading',
    LOADED: 'Loaded',
    DOWNLOADED: 'Downloaded',
    ERROR: 'Error',
    DEFAULT: 'Default'
}